
export enum EmailFormatCd {
	HTML = 'HTML',
	TEXT = 'text'}

